import React from 'react';
import { View } from 'react-native';
import moment from 'moment';

import { machineStatusName, subStatusName, convertTimeLetter, formatTimeEvent, formatSinceTime } from '@helpers';
import Line from '@components/common/line';

import NcFileIcon from './NCFileIcon';
import { ChangesEventProps } from '@v2/pages/machines/common/types/event';
import { StartEndTime } from '@v2/pages/machines/modules/events/components/combined/CombinedEventComponent';

export default ({ C, selectedItem, setShowEditTime, eventInfo, NCFileInfo, onNcDetailsClick }: ChangesEventProps) => {
  const time = convertTimeLetter(eventInfo.durationInMilliseconds, true);

  const config = [
    { name: 'Status', value: machineStatusName[eventInfo.status as keyof typeof machineStatusName], noArrow: true },
    { name: 'Substatus', value: subStatusName[eventInfo.subStatus as keyof typeof subStatusName] || ' ', noArrow: true },
    { name: 'Execution Mode', value: eventInfo.executionMode || ' ', noArrow: true },
    {
      name: 'Change Time',
      value: formatTimeEvent(time, false),
      secondName: 'Target Change Time',
      secondValue: formatTimeEvent(convertTimeLetter(NCFileInfo.changeTimePerPcsSecond), false),
      noArrow: false,
      onClick: () => setShowEditTime({ changeTimePerPiece: { h: Number(time.h), m: Number(time.m), s: Number(time.s) } }),
    },
    {
      name: 'NC File Selected',
      value: eventInfo.ncFileSelected || '-',
      noArrow: false,
      onClick: () => eventInfo.ncFileSelected && onNcDetailsClick(eventInfo.ncFileSelected),
      ValueIcon: () => <NcFileIcon {...{ C, ncFileStatus: eventInfo.ncFileStatusSelected }} />,
    },
    {
      name: 'NC File Selected Version',
      value: eventInfo.ncFileVersionSequenceNumberSelected || '-',
      noArrow: true,
    },
    { name: 'Machine', value: selectedItem.fullName, noArrow: true },
    { name: 'Start Time', ValueComponent: <StartEndTime dateTime={eventInfo.startedOn} C={C} /> },
    {
      name: 'End Time',
      ValueComponent: (
        <StartEndTime dateTime={moment.utc(eventInfo.startedOn).add(eventInfo.durationInMilliseconds, 'milliseconds').format()} C={C} />
      ),
      noArrow: true,
    },
    {
      name: 'Raw Execution Mode',
      value: eventInfo.rawExecutionMode || ' ',
      noArrow: true,
    },
    {
      name: 'Raw Substatus',
      value: eventInfo.rawSubStatus || ' ',
      noArrow: true,
    },
  ];
  return (
    <View
      style={{
        width: '100%',
      }}
    >
      {config.map((item, index) => (
        <Line
          {...{
            inverted: true,
            bigSize: true,
            item,
            index,
            array: config,
            C,
            roundTop: index === 0,
            roundBottom: index === config.length - 1,
          }}
          key={item.name}
        />
      ))}
    </View>
  );
};
